import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { calculatePrice } from '../../utilities/calculatePrice';

const PriceDisplay = () => {
  const snap = useSnapshot(state.current)
  const [price, setPrice] = useState(null)

  useEffect(() => {
    setPrice(calculatePrice(snap))
  }, [
    snap.initialChoices.threeDModel,
    snap.choices.sidePanels.selected.mode,
    // snap.choices.foam.selected.mode,
    snap.choices.raceNumber.selected.mode,
    snap.choices.sealant.selected.mode,
    snap.choices.ribs.selected.mode,
    snap.prices,
  ])

  if (price === null) return null

  return <span>- ${price.toFixed(2)}</span>
}

export default PriceDisplay